import * as React from "react";
import { Component } from 'react';
import Layout from '../components/global/layout.js'
import Content from '../components/site-map/content.js'
import '@fortawesome/fontawesome-free/css/all.css'; 
import '../sass/app.scss';

class SiteMap extends Component {
  render() {
    return (
      <>
        <Layout section="site-map" page="site-map">
          <Content section="site-map" page="site-map" />
        </Layout>
      </>
    )
  }
}

export default SiteMap;